import { el } from "@dhx/ts-common/dom";
import { IEventSystem } from "@dhx/ts-common/events";
import { PropertyEvents } from "../types";

export class Group {
	private _config: any;

	constructor(conf: any, _ev: IEventSystem<PropertyEvents>) {
		this._config = conf;
	}
	toVDOM() {
		return el(".dhx_group_item.side-bar", this._config.label || "");
	}
}
